import { render, staticRenderFns } from "./importOfSalesFlow.vue?vue&type=template&id=3c6b6d44&scoped=true"
import script from "./importOfSalesFlow.vue?vue&type=script&lang=js"
export * from "./importOfSalesFlow.vue?vue&type=script&lang=js"
import style0 from "./importOfSalesFlow.vue?vue&type=style&index=0&id=3c6b6d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b6d44",
  null
  
)

export default component.exports